// eventBus.js 事件总线
export const eventBus = new EventTarget()
export const KeywordPlanner_CLICK = 'KeywordPlanner-click' // 触发关键词规划器指导动画效果
export const AiBlog_CLICK = 'AiBlog-click' // 触发AI博客指导动画效果
export const OnpageSEO_CLICK = 'OnpageSEO-click' // 触发SEO优化指导动画效果
export const OnpageSEO_LIST_REFRESH = 'OnpageSEO-list-refresh' // 刷新SEO列表数据
